import styles from '../styles/Footer.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
      <p>&copy; 2024 Poker Scoreboard. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
